export default {
  server: import.meta.env.VITE_SOCKET_API_URL,
  path: import.meta.env.VITE_SOCKET_API_PATH
}
